import {Injectable} from '@angular/core';
import {ApiProvider} from "../api/api";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Observable} from "rxjs/Observable";

/**
 * Provides functionality required to check the status of Carlisle offline mode
 */
@Injectable()
export class OfflineModeProvider
{

    private isOfflineMode;
    private offlineModeInterval;

    constructor(private api: ApiProvider)
    {
        console.log('Hello OfflineModeProvider Provider');

        this.isOfflineMode = new BehaviorSubject(true);
    }

    /**
     * Start an interval timer every Xmins to make an API call checking the offline mode status
     * @returns {Promise<boolean>}
     */
    public startOfflineModeInterval(): Promise<boolean>
    {
        this.offlineModeInterval = setInterval(() =>
        {
            this.checkOfflineMode();
        }, 300000); // Time in ms (5min)
        return this.checkOfflineMode();
    }

    /**
     * Wrapper around calling the API to get offline mode status and then passing the new status to our observable so that the app always has access to the latest retrieved value
     * May also be called as a once off ot retrieve the latest offline mode status
     * @returns {Promise<boolean>}
     */
    public checkOfflineMode(): Promise<boolean>
    {
        return this.api.getOfflineMode().then((response: any) =>
        {
            console.info('Response from getOfflineMode:', response);
            let isOfflineMode = true;
            if (response && response.isOffline === false)
            {
                isOfflineMode = false;
            }
            this.setOfflineMode(isOfflineMode);
            return isOfflineMode;
        }).catch(error =>
        {
            console.error('Error occurred checking offline mode status:', error);
            this.setOfflineMode(true);
            return true;
        })
    }

    /**
     * Sets the status of offline mode by passing the new value to our observable
     * @param isOfflineMode <boolean> status to set offline mode to, true for offline mode is active
     * @returns {boolean} the value set
     */
    private setOfflineMode(isOfflineMode): boolean
    {
        console.log('Setting offline mode:', isOfflineMode);
        if (typeof isOfflineMode !== typeof true)
        {
            console.error('Required parameter "isOfflineMode" type error, expected boolean');
            throw new TypeError(`Invalid parameter - expected boolean got ${typeof isOfflineMode}`);
        }
        this.isOfflineMode.next(isOfflineMode);
        return isOfflineMode;
    }

    /**
     * Get an observable that will receive the latest offline mode status every Xmins
     * Requires that startOfflineModeInterval is called first or else receives a default value of true
     * @returns {Observable<boolean>}
     */
    public getOfflineMode(): Observable<boolean>
    {
        return this.isOfflineMode.asObservable();
    }

}



// WEBPACK FOOTER //
// ./src/providers/offline-mode/offline-mode.ts